import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'

const base = 'contract-templates'

AdminRouter.addRoutes([
  {
    name: `${base}`,
    path: `/${base}`,
    component: () => import('./Index.vue'),
    meta: {
      auth: true,
    },
  },
])

AdminSidebar.pushItem({
  id: `${base}`,
  order: 200,
  text: $vm => $vm.$t('settings.sections.contract_templates'),
  route: {
    name: `${base}`,
  },
  icon: 'icon-pdf',
  permission: 'administer',
})
